module.exports = __webpack_public_path__ + "static/media/01-foto-don-alberto@2x.3d593145.jpg";